import React from 'react'
import propTypes from 'prop-types'
import TextLink from '../TextLink/TextLink'
import Tag from '../Tag/Tag'

import './PageHeader.scss'

const PageHeader = ({ title, subtitle, backPath, children, tag }) => {
  return (
    <header className='page-header'>
      <div className='text-container'>
        {tag && <Tag label={tag} />}
        {backPath === 0 && (
          <TextLink
            to={backPath}
            label='Back to Projects'
            iconLeft='chevron-left'
          />
        )}
        <h1>{title}</h1>
        {subtitle && <span className='subtitle'>{subtitle}</span>}
      </div>
      {children}
    </header>
  )
}

PageHeader.defaultProps = {
  subtitle: '',
  backPath: '',
  children: null,
}

PageHeader.propTypes = {
  title: propTypes.string.isRequired,
  subtitle: propTypes.oneOfType([propTypes.shape(), propTypes.string]),
  backPath: propTypes.string,
  children: propTypes.shape(),
  tag: propTypes.string,
}

export default PageHeader
